export enum KnmResultDecisionAgreementStatusEnum {
  AGREEMENT_DRAFT = 'AGREEMENT_DRAFT',
  AGREEMENT_CANCELED = 'AGREEMENT_CANCELED',
  AGREEMENT_READY_TO_APPROVE = 'AGREEMENT_READY_TO_APPROVE',
  AGREEMENT_ON_APPROVAL = 'AGREEMENT_ON_APPROVAL',
  AGREEMENT_APPROVED = 'AGREEMENT_APPROVED',
  AGREEMENT_DENIED = 'AGREEMENT_DENIED',
  AGREEMENT_NOT_COMPLETED_WAITING_TERMINATION = 'AGREEMENT_NOT_COMPLETED_WAITING_TERMINATION',
  AGREEMENT_TERMINATED = 'AGREEMENT_TERMINATED',
  AGREEMENT_COMPLETED = 'AGREEMENT_COMPLETED',
  AGREEMENT_NOT_COMPLETED = 'AGREEMENT_NOT_COMPLETED',
}
